(() => {
  'use strict';

  function initCartActions() {
    const actions = window.Shopify?.actions;
    if (!actions) return;
    actions.updateCart.configure({
      eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
    });
    actions.openCart.configure({
      async handler() {
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer?.open) drawer.open();
        else window.location.href = window.Theme?.routes?.cart_url || '/cart';
      },
    });
  }

  function normalizeAboutLinks() {
    const localeRoot = document.documentElement.lang.toLowerCase().startsWith('zh') ? '/zh' : '';
    const correctUrl = `${localeRoot}/pages/about-us`;
    document.querySelectorAll('a[href$="/about-us"]').forEach((link) => {
      link.href = correctUrl;
    });
  }

  function hideEmptyTripQuickAdd() {
    if (document.getElementById('leda-hide-trip-quick-add')) return;
    const style = document.createElement('style');
    style.id = 'leda-hide-trip-quick-add';
    style.textContent = `
      product-card quick-add-component.quick-add{display:none!important}
      .leda-filter-box{display:inline-grid;place-items:center;width:19px;height:19px;margin-right:9px;border:1px solid #b8aab1;border-radius:5px;color:transparent;font-size:13px}
      .leda-trip-filter:checked+.checkbox__label .leda-filter-box{border-color:#d63384;background:#d63384;color:#fff}
      .leda-offer-facet .checkbox__label-text{font:inherit;color:inherit}
      .menu-list__submenu .mega-menu__column>div{margin:0!important}
      .menu-list__submenu .mega-menu__column .mega-menu__link{display:flex!important;align-items:center;min-height:50px;padding:10px 0!important;line-height:1.25!important}
      .menu-drawer__list-item .menu-drawer__menu-item--child{min-height:48px;padding-block:10px!important;line-height:1.25!important}
      .leda-stable-results results-list,.leda-stable-results .product-grid__item,.leda-stable-results product-card{transition:none!important;animation:none!important}
    `;
    document.head.appendChild(style);
  }

  function stabilizeSearchPage() {
    if (!location.pathname.includes('/search')) return;
    document.documentElement.classList.add('leda-stable-results');
    document.addEventListener('click', (event) => {
      const reset = event.target.closest('.search__reset-button');
      if (!reset) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = reset.closest('form');
      const input = form?.querySelector('input[type="search"][name="q"]');
      if (input) {
        input.value = '';
        input.focus({ preventScroll: true });
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }, true);
  }

  function mergeServiceNavigation() {
    const isChinese = document.documentElement.lang.toLowerCase().startsWith('zh');
    if (isChinese) {
      const translations = new Map([
        ['Private Group Tours', '私人包团'],
        ['Day Tour', '一日游'],
        ['Private Charter Service', '私人包车服务'],
        ['Club Med', 'Club Med 度假村'],
        ['Airport Transfer', '机场接送'],
        ['Cruise', '邮轮假期'],
      ]);
      document.querySelectorAll('a').forEach((link) => {
        const label = link.querySelector('.wrap-text,.menu-drawer__menu-item-text') || link;
        const translated = translations.get(label.textContent.trim());
        if (translated) label.textContent = translated;
      });
    }
  }

  function bestFor(title) {
    const text = title.toLowerCase();
    const values = ['Private pace'];
    if (/tokyo|osaka|kyoto|hokkaido|seoul|busan|jeju|classic|highlight|东京|大阪|京都|北海道|首尔|釜山|济州|经典/.test(text)) values.push('First-time');
    if (/family|theme park|disney|universal|flower|fruit|tokyo|osaka|kyoto|家庭|亲子|主题|迪士尼|环球|花|水果/.test(text)) values.push('Family & friends');
    return [...new Set(values)];
  }

  function addFilterPanel(anchor, title, className, choices) {
    const panel = document.createElement('details');
    panel.className = `facets__panel ${className}`;
    panel.open = true;
    panel.innerHTML = `<summary class="facets__summary"><span class="facets__label">${title}</span><span aria-hidden="true">⌄</span></summary><div class="facets__inputs facets__panel-content details-content"><ul class="facets__inputs-list list-unstyled"></ul></div>`;
    const list = panel.querySelector('ul');
    choices.forEach((choice, index) => {
      const item = document.createElement('li');
      const id = `Leda-${className}-${index}`;
      item.className = 'facets__inputs-list-item';
      item.innerHTML = `<div class="checkbox"><input class="checkbox__input leda-trip-filter" type="checkbox" id="${id}" data-group="${className}" value="${choice}"><label class="checkbox__label" for="${id}"><span class="leda-filter-box">✓</span><span class="checkbox__label-text">${choice}</span></label></div>`;
      list.appendChild(item);
    });
    anchor.insertAdjacentElement('afterend', panel);
    return panel;
  }

  async function installTripFilters() {
    if (!(location.pathname.includes('/collections/') || location.pathname.includes('/search')) || document.querySelector('.leda-best-for-facet')) return;
    const cards = [...document.querySelectorAll('product-card')];
    const filterWrapper = document.querySelector('.facets--vertical .facets__filters-wrapper');
    const anchor = filterWrapper?.querySelector('.facets__item:last-of-type') || filterWrapper?.querySelector('.facets__panel:last-of-type');
    if (!cards.length || !anchor) return;

    const bestPanel = addFilterPanel(anchor, 'Best for', 'leda-best-for-facet', ['First-time', 'Family & friends', 'Private pace']);
    const seasonPanel = addFilterPanel(bestPanel, 'Travel season', 'leda-season-facet', ['Spring', 'Summer', 'Autumn', 'Winter', 'Year-round']);
    addFilterPanel(seasonPanel, 'Featured offers', 'leda-offer-facet', ['LEDA PICK', 'HOT DEALS']);

    await Promise.all(cards.map(async (card) => {
      const item = card.closest('.product-grid__item');
      if (!item) return;
      const title = (card.querySelector('h3,h2,[class*="title"]')?.textContent || '').trim();
      const rawSeason = (card.getAttribute('data-travel-season') || 'Year-round').replace(/&quot;|[\[\]"]/g, '');
      item.dataset.ledaBestFor = bestFor(title).join('|');
      item.dataset.ledaSeasons = rawSeason || 'Year-round';
      let offers = [];
      const href = card.querySelector('a[href*="/products/"]')?.href;
      if (href) {
        try {
          const handle = new URL(href).pathname.split('/products/')[1].split('/')[0];
          const product = await fetch(`/products/${handle}.js`).then((response) => response.json());
          const tags = (product.tags || []).map((tag) => String(tag).toUpperCase());
          if (tags.some((tag) => tag === 'LEDA PICK' || tag === 'LEDA-PICK')) offers.push('LEDA PICK');
          if (tags.some((tag) => tag === 'HOT DEALS' || tag === 'HOT DEAL' || tag === 'HOT-DEALS')) offers.push('HOT DEALS');
          if (!offers.includes('HOT DEALS') && product.variants?.some((variant) => Number(variant.compare_at_price) > Number(variant.price))) offers.push('HOT DEALS');
        } catch (_) {}
      }
      if (!offers.length && /classic|essential|highlight/i.test(title)) offers.push('LEDA PICK');
      item.dataset.ledaOffers = offers.join('|');
    }));

    function applyFilters() {
      const selected = {};
      document.querySelectorAll('.leda-trip-filter:checked').forEach((input) => {
        (selected[input.dataset.group] ||= []).push(input.value);
      });
      document.querySelectorAll('.product-grid__item').forEach((item) => {
        const groups = {
          'leda-best-for-facet': item.dataset.ledaBestFor || '',
          'leda-season-facet': item.dataset.ledaSeasons || '',
          'leda-offer-facet': item.dataset.ledaOffers || '',
        };
        item.hidden = Object.entries(selected).some(([group, values]) => values.length && !values.some((value) => groups[group].split('|').includes(value)));
      });
    }
    document.addEventListener('change', (event) => {
      if (event.target.matches('.leda-trip-filter')) applyFilters();
    });
  }

  function installProductDateCalendars() {
    const inputs = document.querySelectorAll('.ledatrip-departure-date input[type="date"], .ledatrip-departure-date input[data-leda-product-date]');
    if (!inputs.length) return;
    if (!document.getElementById('leda-product-calendar-style')) {
      const style = document.createElement('style');
      style.id = 'leda-product-calendar-style';
      style.textContent = `
        .leda-date-pop{position:fixed;z-index:99999;width:min(360px,calc(100vw - 24px));padding:18px;background:#fff;border:1px solid #e7b5cf;border-radius:18px;box-shadow:0 18px 54px rgba(63,20,45,.24);color:#541b3b;font-family:inherit}
        .leda-date-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}.leda-date-title{font-size:18px;font-weight:750}.leda-date-nav{display:flex;gap:6px}.leda-date-nav button,.leda-date-foot button{border:0;background:transparent;color:#70234e;font:inherit;font-weight:700;cursor:pointer;padding:7px 9px;border-radius:9px}.leda-date-nav button:hover,.leda-date-foot button:hover{background:#fff0f7}
        .leda-date-days,.leda-date-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:5px;text-align:center}.leda-date-days{margin-bottom:7px;color:#8c6077;font-size:12px;font-weight:700}.leda-date-grid button{aspect-ratio:1;border:0;border-radius:50%;background:transparent;color:#351326;font:inherit;cursor:pointer}.leda-date-grid button:hover{background:#ffe4f1}.leda-date-grid button[disabled]{color:#c9bfc4;cursor:not-allowed}.leda-date-grid .is-today{box-shadow:inset 0 0 0 1px #d63384}.leda-date-grid .is-selected{background:#70234e;color:#fff}
        .leda-date-foot{display:flex;justify-content:space-between;border-top:1px solid #f1d6e3;margin-top:12px;padding-top:9px}
        .ledatrip-departure-date input[data-leda-product-date]{cursor:pointer;background:#fff}
        @media(max-width:540px){.leda-date-pop{padding:14px;border-radius:15px}}
      `;
      document.head.appendChild(style);
    }
    inputs.forEach((input) => {
      if (input.dataset.calendarReady) return;
      input.dataset.calendarReady = '1';
      input.dataset.ledaProductDate = 'true';
      input.type = 'text';
      input.readOnly = true;
      input.autocomplete = 'off';
      input.placeholder = document.documentElement.lang.toLowerCase().startsWith('zh') ? '年/月/日' : 'Select a date';
      const zh = document.documentElement.lang.toLowerCase().startsWith('zh');
      const months = zh ? ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'] : ['January','February','March','April','May','June','July','August','September','October','November','December'];
      const weekdays = zh ? ['日','一','二','三','四','五','六'] : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      const getBounds = () => {
        const p = new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Tokyo',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const n = (t) => Number(p.find(x => x.type === t).value);
        const today = new Date(n('year'), n('month')-1, n('day'));
        const minimum = new Date(today);
        minimum.setDate(minimum.getDate()+14);
        const oldMin = input.getAttribute('min');
        if (oldMin && /^\d{4}-\d{2}-\d{2}$/.test(oldMin)) {
          const [y,m,d] = oldMin.split('-').map(Number);
          const strict = new Date(y,m-1,d);
          if (strict > minimum) return {today,minimum:strict};
        }
        return {today,minimum};
      };
      const firstMinimum = getBounds().minimum;
      let view = new Date(firstMinimum.getFullYear(),firstMinimum.getMonth(),1), selected = null, pop = null;
      const pad = (number) => String(number).padStart(2,'0');
      const value = (date) => `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}`;
      const place = () => {
        if (!pop) return;
        const rect = input.getBoundingClientRect(), width = Math.min(360,innerWidth-24);
        const left = Math.max(12,Math.min(rect.left,innerWidth-width-12));
        let top = rect.bottom + 8;
        if (top + 430 > innerHeight) top = Math.max(12,rect.top-410);
        pop.style.left = `${left}px`; pop.style.top = `${top}px`;
      };
      const close = () => {
        if (!pop) return;
        pop.remove(); pop = null;
        removeEventListener('resize',place); removeEventListener('scroll',place,true);
      };
      const commit = (date) => {
        if (date < getBounds().minimum) return;
        selected = new Date(date);
        input.value = value(selected);
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
        close();
      };
      const render = () => {
        const {today,minimum} = getBounds();
        const first = new Date(view.getFullYear(),view.getMonth(),1);
        const last = new Date(view.getFullYear(),view.getMonth()+1,0);
        let html = `<div class="leda-date-head"><div class="leda-date-title">${months[view.getMonth()]} ${view.getFullYear()}</div><div class="leda-date-nav"><button type="button" data-prev aria-label="${zh?'上个月':'Previous month'}">←</button><button type="button" data-next aria-label="${zh?'下个月':'Next month'}">→</button></div></div><div class="leda-date-days">`;
        weekdays.forEach((day) => { html += `<span>${day}</span>`; });
        html += '</div><div class="leda-date-grid">';
        for (let index=0; index<first.getDay(); index++) html += '<span></span>';
        for (let day=1; day<=last.getDate(); day++) {
          const current = new Date(view.getFullYear(),view.getMonth(),day);
          const disabled = current < minimum;
          const classes = `${current.getTime()===today.getTime()?'is-today ':''}${selected&&current.getTime()===selected.getTime()?'is-selected':''}`;
          html += `<button type="button" data-day="${day}" class="${classes}" ${disabled?'disabled':''}>${day}</button>`;
        }
        html += `</div><div class="leda-date-foot"><button type="button" data-clear>${zh?'清除':'Clear'}</button><button type="button" data-today>${zh?'最早可订':'Earliest available'}</button></div>`;
        pop.innerHTML = html;
        pop.querySelector('[data-prev]').onclick = () => { view.setMonth(view.getMonth()-1); render(); };
        pop.querySelector('[data-next]').onclick = () => { view.setMonth(view.getMonth()+1); render(); };
        pop.querySelector('[data-clear]').onclick = () => { input.value=''; input.dispatchEvent(new Event('change',{bubbles:true})); close(); };
        pop.querySelector('[data-today]').onclick = () => commit(getBounds().minimum);
        pop.querySelectorAll('[data-day]').forEach((button) => { button.onclick = () => commit(new Date(view.getFullYear(),view.getMonth(),Number(button.dataset.day))); });
      };
      const open = () => {
        if (pop) { close(); return; }
        const minimum = getBounds().minimum;
        view = new Date(minimum.getFullYear(),minimum.getMonth(),1);
        validateDate();
        if (input.value) {
          const parts = input.value.split('-');
          if (parts.length===3) { selected=new Date(+parts[0],+parts[1]-1,+parts[2]); view=new Date(selected.getFullYear(),selected.getMonth(),1); }
        }
        pop=document.createElement('div'); pop.className='leda-date-pop'; pop.setAttribute('role','dialog'); pop.setAttribute('aria-label',zh?'选择日期':'Choose a date');
        document.body.appendChild(pop); render(); place();
        addEventListener('resize',place); addEventListener('scroll',place,true);
      };
      const validateDate = () => {
        if (!input.value) return;
        const match = input.value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        const date = match ? new Date(+match[1],+match[2]-1,+match[3]) : null;
        if (!date || value(date)!==input.value || date<getBounds().minimum) {
          input.value=''; selected=null;
          input.dispatchEvent(new Event('input',{bubbles:true}));
          input.dispatchEvent(new Event('change',{bubbles:true}));
        }
      };
      input.addEventListener('input',validateDate);
      input.addEventListener('change',validateDate);
      validateDate();
      input.addEventListener('click',open);
      input.addEventListener('keydown',(event) => { if(event.key==='Enter'||event.key===' '){event.preventDefault();open();} if(event.key==='Escape')close(); });
      document.addEventListener('pointerdown',(event) => { if(pop&&event.target!==input&&!pop.contains(event.target))close(); });
    });
  }

  async function openLedaChat(context = {}) {
    const payload = {
      page_title: document.querySelector('main h1')?.textContent?.trim() || document.title,
      page_url: location.href,
      page_type: location.pathname.includes('/products/') ? 'product' : 'page',
      ...context,
      started_at: new Date().toISOString(),
    };
    try { sessionStorage.setItem('leda_inquiry_context', JSON.stringify(payload)); } catch (_) {}
    try { window.Shopify?.analytics?.publish?.('leda_inquiry_started', payload); } catch (_) {}
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    await customElements.whenDefined('shopify-chat');
    // Let Shopify Inbox choose managed/standalone mode and coordinate its own
    // drawer. Calling show() is the supported path and keeps native close,
    // history, sign-in and staff handoff behavior intact.
    if (typeof chat.show === 'function') await chat.show();
    else chat.setAttribute('open', '');
  }

  function installContextualChat() {
    if (!document.getElementById('leda-contextual-chat-style')) {
      const style = document.createElement('style');
      style.id = 'leda-contextual-chat-style';
      style.textContent = `
        :root{--shopify-chat-activator-offset:112px!important}
        .leda-smart-assistant{display:none!important}
        .leda-product-inquiry{display:flex;width:100%;align-items:center;justify-content:space-between;gap:18px;margin-top:12px;padding:16px 19px;border:1px solid #d63384;border-radius:999px;background:#fff7fb;color:#642342;text-align:left;cursor:pointer;font:inherit;transition:background .2s ease,transform .2s ease,box-shadow .2s ease}
        .leda-product-inquiry:hover{background:#ffedf6;transform:translateY(-1px);box-shadow:0 10px 24px rgba(112,35,78,.12)}
        .leda-product-inquiry span{display:flex;min-width:0;flex-direction:column;gap:3px}.leda-product-inquiry strong{font-size:15px}.leda-product-inquiry small{overflow:hidden;color:#81536c;font-size:11px;text-overflow:ellipsis;white-space:nowrap}.leda-product-inquiry b{flex:0 0 auto;font-size:20px}
        @media(max-width:560px){:root{--shopify-chat-activator-offset:96px!important}.leda-product-inquiry{border-radius:18px;padding:14px 16px}}
      `;
      document.head.appendChild(style);
    }

    // Shopify Inbox is now the only floating live-chat launcher. Remove the
    // former recommendation launcher so customers do not see duplicate chat CTAs.
    document.querySelectorAll('.leda-smart-assistant').forEach((assistant) => assistant.remove());

    if (!location.pathname.includes('/products/')) return;
    const productRoot = document.querySelector('product-information, [data-product-id], main');
    if (!productRoot || productRoot.querySelector('.leda-product-inquiry')) return;
    const addToCart = [...productRoot.querySelectorAll('button')].find((button) => /add to cart|check availability|加入购物车|确认日期与价格/i.test(button.textContent || ''));
    const anchor = productRoot.querySelector('.leda-product-customize-top') || addToCart;
    if (!anchor) return;
    const isZh = document.documentElement.lang.toLowerCase().startsWith('zh');
    const title = (document.querySelector('main h1')?.textContent || document.title).trim();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'leda-product-inquiry';
    button.innerHTML = `<span><strong>${isZh ? '咨询这个行程' : 'Ask about this tour'}</strong><small>${title.replace(/[&<>"']/g, '')}</small></span><b aria-hidden="true">→</b>`;
    button.addEventListener('click', () => openLedaChat({ source: 'product_inquiry_button', product_title: title, product_url: location.href }));
    anchor.insertAdjacentElement('afterend', button);
  }

  function init() {
    initCartActions();
    normalizeAboutLinks();
    hideEmptyTripQuickAdd();
    mergeServiceNavigation();
    stabilizeSearchPage();
    installTripFilters();
    installProductDateCalendars();
    installContextualChat();
    // Header submenus can finish rendering just after DOMContentLoaded.
    // Re-run this small, idempotent label pass without observing the whole page.
    setTimeout(mergeServiceNavigation, 300);
    setTimeout(mergeServiceNavigation, 1200);
    setTimeout(installProductDateCalendars, 300);
    setTimeout(installProductDateCalendars, 1200);
    setTimeout(installContextualChat, 400);
    setTimeout(installContextualChat, 1400);
    setTimeout(installContextualChat, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
